const SessionStore = {
  namespaced: true,

  state: {
    user: undefined,
    loggedIn: undefined
  },


  mutations: {
    /**
     * create new user object in state
     *
     * @param {Object} state
     * @param {Object} user
     */
    setUser(state, user) {
      state.user = user; // Copy user object.
      state.loggedIn = user.loggedIn;
    },

    /**
     * removed user object
     *
     * @param {Object} state
     */
    removeUser(state) {
      state.user = {};
      state.loggedIn = false;
    }
  },


  actions: {
    /**
     * login new user to app
     *
     * @param {Function} commit
     * @param {Object} user
     */
    login({commit}, user) {
      commit('setUser', {...user});
    },

    /**
     * logout user from app
     *
     * @param {Function} commit
     */
    logout({commit}) {
      commit('removeUser');
    }
  },


  getters: {
    /**
     * get current user object
     * @param {Object} state
     * @return {Object}
     */
    getUser(state) {
      return state.user;
    },

    /**
     * get login state
     * @param {Object} state
     * @return {boolean}
     */
    isLoggedIn(state) {
      return state.loggedIn;
    }
  }
};

export default SessionStore;
